<template>
    <ValidationProvider
        :mode="validationMode"
        :name="label || name || 'unknown'"
        :rules="rules"
        :vid="uniqueId"
        slim
        v-slot="{ validated, valid, errors }"
    >
        <rkm-form-group
            :invalid-feedback="errors[0]"
            :label="label ? (label + (rules && rules.required ? ' *' : '')) : null"
            :state="rules ? (disabled ? null : (validated ? valid : null)) : null"
        >
            <vue-editor
                :disabled="disabled"
                :placeholder="placeholder"
                :value="value"
                @blur="$emit('blur', $event)"
                @focus="$emit('focus', $event)"
                @image-added="$emit('image-added', $event)"
                @image-removed="$emit('image-removed', $event)"
                @input="$emit('input', $event)"
                @selection-change="$emit('selection-change', $event)"
            />
        </rkm-form-group>
    </ValidationProvider>
</template>

<script>
import {VueEditor} from "vue2-editor"
import {ValidationProvider} from 'vee-validate';

export default {
    components: { VueEditor, ValidationProvider },
    computed: {
        rules() {
            return this.disabled ? null : this.validations
        },
    },
    props: {
        disabled: {type: Boolean},
        label: {type: String},
        name: {type: String},
        placeholder: {type: String},
        validationMode: {type: String, default: 'lazy'},
        validations: {type: Object, default: null},
        value: {type: [Number, String]},
    },
}
</script>